(function IIFE() {
    const pickers = document.querySelectorAll('bundle-picker.bundle-picker');
    const newPickers = document.querySelectorAll('.product-bundle-picker--new');
    if (!pickers.length && !newPickers.length) return;

    const translationScript = document.querySelector('script[data-bundle-translations]');
    
    const optionNameTranslations = (() => {
        if (!translationScript) return new Map();

        try {
            const parsedTranslations = JSON.parse(translationScript.textContent);
            if (!parsedTranslations || typeof parsedTranslations !== 'object' || Array.isArray(parsedTranslations)) {
                return new Map();
            }

            return new Map(
                Object.entries(parsedTranslations).map(([name, translation]) => [
                    name.replaceAll('_', ' ').trim().toLocaleLowerCase(),
                    translation,
                ])
            );
        } catch (error) {
            console.warn('BundlePicker: Invalid bundle translation config; using default option names', error);
            return new Map();
        }
    })();

    const getOptionDisplayName = (optionName = '') => {
        const defaultName = optionName.replace('_', '');
        const normalizedName = optionName.replaceAll('_', ' ').trim().toLocaleLowerCase();
        const translatedName = optionNameTranslations.get(normalizedName);

        return typeof translatedName === 'string' && translatedName.trim() ? translatedName : defaultName;
    };

    class BundlePicker extends HTMLElement {
        constructor() {
            super();

            this.isPreselectVariant = false;
            this.preselectVariants = '';
            this.configScript = null;
            this.bundleConfig = [];
            this.colorConfig = [];
            this.swatchMap = {};
            this.optionMap = null;
            this.productId = '';
            this.instanceId = `bundle-picker-${BundlePicker.instanceCount++}`;

            this.boundHandleChange = this.handleChange.bind(this);
        }

        connectedCallback() {
            this.isPreselectVariant = this.dataset.isPreselectVariant === 'true';
            if (this.isPreselectVariant === true) {
                this.preselectVariants = this.dataset.preselectVariants.split(',');
            }
            this.configScript = this.querySelector('script[data-variant]');
            this.configColorScript = this.querySelector('script[data-color]');
            if (!this.configScript) return;

            this.bundleConfig = this.parseConfig(this.configScript);
            const parsedColorConfig = this.parseConfig(this.configColorScript);
            this.colorConfig = Array.isArray(parsedColorConfig) ? parsedColorConfig : parsedColorConfig.colors || [];
            this.swatchMap = Array.isArray(parsedColorConfig) ? {} : parsedColorConfig.swatches || {};
            this.colorMap = new Map(
                this.colorConfig.filter((item) => item?.name).map((item) => {
                    const name = String(item.name).toLocaleLowerCase();
                    const itemSwatches = item.swatch || {};

                    return [
                        name,
                        {
                            color: item.color,
                            label: item.label,
                            swatch_1: this.swatchMap[name] || itemSwatches[name] || null,
                            swatch_2: this.swatchMap[`${name}_2`] || itemSwatches[`${name}_2`] || null,
                            swatch_3: this.swatchMap[`${name}_3`] || itemSwatches[`${name}_3`] || null,
                            swatch_4: this.swatchMap[`${name}_4`] || itemSwatches[`${name}_4`] || null,
                            swatch_5: this.swatchMap[`${name}_5`] || itemSwatches[`${name}_5`] || null,
                        },
                    ];
                })
            );
            this.optionMap = this.buildOptionMap(this.bundleConfig);
            this.productId = this.dataset.productId;

            if (!this.optionMap) return;

            this.render();
            this.bindEvents();
            this.dispatchInitEvent();
        }

        disconnectedCallback() {
            this.unbindEvents();
        }

        render() {
            const container = this.querySelector('.bundle-picker__inner');
            if (!container) {
                console.warn('BundlePicker: .bundle-picker__inner not found');
                return;
            }

            const fragment = document.createDocumentFragment();

            Object.entries(this.optionMap).forEach(([optionName, optionData], index) => {
                const swatchKey = `swatch_${index + 1}`;
                const normalizedOptionName = this.normalizeOptionName(optionName);
                const relatedSelect = this.findRelatedSelect(normalizedOptionName);
                const selectedValue = relatedSelect?.value;

                const fieldset = document.createElement('fieldset');
                fieldset.dataset.optionName = optionName;

                const legend = document.createElement('legend');
                const small = document.createElement('small');
                small.textContent = '';
                legend.textContent = `${getOptionDisplayName(optionName)}: `;
                legend.appendChild(small);

                fieldset.appendChild(legend);
                optionData.values.forEach((value, index) => {
                    const id = `${normalizedOptionName}-${index}-${this.productId}-${this.instanceId}`;

                    const input = document.createElement('input');
                    input.type = 'radio';
                    input.name = `${normalizedOptionName}-${this.productId}-${this.instanceId}`;
                    input.value = value;
                    input.id = id;

                    if (selectedValue === value) {
                        input.checked = true;
                    }

                    const labelColor = optionData.colors[index] || value;
                    const colorInMap = this.colorMap.get(String(labelColor).toLocaleLowerCase()) || {};
                    input.setAttribute('data-label', colorInMap.label || labelColor);
                    const label = document.createElement('label');
                    label.setAttribute('for', id);
                    const span = document.createElement('span');
                    const swatch = colorInMap[swatchKey] || colorInMap['swatch_1'];
                    if (colorInMap.color || swatch) {
                        if (colorInMap.color) span.style.setProperty('--swatch--background', colorInMap.color);
                        label.classList.add('is-swatch');
                        if (swatch) {
                            span.style.setProperty('--swatch-image', `url(${swatch})`);
                            label.classList.add('is-swatch--image');
                        }
                    }
                    span.textContent = optionData.colors[index] || value;
                    label.append(span);
                    fieldset.append(input, label);
                });

                if (this.isPreselectVariant === true && Array.isArray(this.preselectVariants)) {
                    const allInputs = fieldset.querySelectorAll('input');
                    const preselectVariant = this.preselectVariants[index]?.trim().toLocaleLowerCase();
                    const preselectInput = preselectVariant
                        ? [...allInputs].find((input) => input.value.toLocaleLowerCase().includes(preselectVariant))
                        : null;
                    if (preselectInput) {
                        preselectInput.checked = true;
                    }
                }

                if (!fieldset.querySelector('input:checked')) {
                    const firstInput = fieldset.querySelector('input');
                    if (firstInput) firstInput.checked = true;
                }

                fragment.appendChild(fieldset);
            });

            container.replaceChildren(fragment);
            container.removeAttribute('aria-busy');
        }

        bindEvents() {
            this.addEventListener('change', this.boundHandleChange);
        }

        unbindEvents() {
            this.removeEventListener('change', this.boundHandleChange);
        }

        handleChange(event) {
            const input = event.target;
            if (input.type !== 'radio') return;

            const fieldset = input.closest('fieldset');
            if (!fieldset) return;

            const optionName = fieldset.dataset.optionName;
            const normalizedOptionName = this.normalizeOptionName(optionName);

            this.syncSelect(normalizedOptionName, input.value);

            this.dispatchChangeEvent({
                optionName,
                value: input.value,
                inputElement: input,
            });
        }

        syncSelect(optionKey, value) {
            const select = this.findRelatedSelect(optionKey);
            if (!select) return;

            if (select.value !== value) {
                select.value = value;
                select.dispatchEvent(new Event('change', { bubbles: true }));
            }
        }

        findRelatedSelect(optionKey) {
            const localSelector = this.parentElement?.previousElementSibling;
            if (localSelector?.classList.contains('bundle-app-selector')) {
                return localSelector.querySelector(`[data-option-key="${CSS.escape(optionKey)}"]`);
            }

            const root =
                this.closest('product-info, .main-product-upsells__item, .main-product-picker__item') || this.offsetParent;
            if (!root) return null;

            return root.querySelector(`#${CSS.escape(optionKey)}, [data-option-key="${CSS.escape(optionKey)}"]`);
        }

        dispatchInitEvent() {
            queueMicrotask(() => {
                this.dispatchEvent(
                    new CustomEvent('bundle-picker:init', {
                        bubbles: true,
                        detail: {
                            optionMap: this.optionMap,
                        },
                    })
                );
            });
        }

        dispatchChangeEvent(detail) {
            this.dispatchEvent(
                new CustomEvent('bundle-picker:change', {
                    bubbles: true,
                    detail: {
                        ...detail,
                        optionMap: this.optionMap,
                    },
                })
            );
        }

        parseConfig(scriptTag) {
            try {
                return JSON.parse(scriptTag.textContent) || [];
            } catch (error) {
                console.error('BundlePicker: Invalid JSON config', error);
                return [];
            }
        }

        buildOptionMap(config = []) {
            if (!Array.isArray(config) || !config.length) return null;

            const optionMap = {};

            config.forEach(({ optionName, optionValues }) => {
                if (!optionName || !optionValues) return;

                const values = String(optionValues)
                    .split(',')
                    .map((v) => v.trim())
                    .filter(Boolean);

                if (values.length < 2) return;

                optionMap[optionName] = { values };
                optionMap[optionName].colors = [];
                values.forEach((value) => {
                    const normalizedValue = value
                        .split('-')
                        .map((element) => element.trim().toLocaleLowerCase())
                        .splice(1)
                        .join('-');
                    optionMap[optionName].colors.push(normalizedValue);
                });
            });

            return optionMap;
        }

        changeLegendText() {
            this.querySelectorAll('fieldset').forEach((fieldset) => {
                const labelValue = fieldset.querySelector('legend small');
                const checkedInput = fieldset.querySelector('input:checked');
                const label = checkedInput?.dataset.label;
                if (label && labelValue) labelValue.textContent = label;
            });
        }

        normalizeOptionName(name = '') {
            return name.trim().toLowerCase().replaceAll(' ', '-');
        }
    }

    BundlePicker.instanceCount = 0;

    if (!customElements.get('bundle-picker')) {
        customElements.define('bundle-picker', BundlePicker);
    }

    pickers.forEach((picker) => {
        if (!picker) return;

        const updateLegendText = () => {
            picker.changeLegendText?.call(picker);
        };

        const updateBundleSelectionInput = (event) => {
            updateLegendText();

            const root =
                event?.target?.closest('.main-product-upsells__item, .main-product-picker__item') ||
                event?.target?.offsetParent;
            if (!root) return;

            const bundleInput = root.querySelector('.bundle-app-selector input[name="properties[_bundle_selection]"]');
            if (!bundleInput) return;

            const selects = root.querySelectorAll('.bundle-app-selector select');
            const values = [...selects].map((select) => select.value).filter(Boolean);

            bundleInput.value = values.join(' <> ');
        };

        picker.addEventListener('bundle-picker:init', (event) => {
            updateLegendText();
            const { target } = event;
            const upsellItem = target.closest('.main-product-upsells__item');
            const hasBundleContent = !!upsellItem?.querySelector('fieldset');
            if (upsellItem && hasBundleContent) {
                upsellItem?.querySelector('.app-bundle-inputs')?.remove();
            }

            if ('isPreselectVariant' in picker && picker.isPreselectVariant == true) {
                picker
                    .querySelectorAll('input:checked')
                    .forEach((input) => input.dispatchEvent(new Event('change', { bubbles: true })));
            }
        });
        picker.addEventListener('bundle-picker:change', updateBundleSelectionInput);
    });

    newPickers.forEach((picker) => {
        const localRoot = picker.closest('product-form, .main-product-upsells__item, .main-product-picker__item');
        const root = localRoot || picker.closest('product-info') || picker.offsetParent;
        const bundleSelector = localRoot?.querySelector('.bundle-app-selector');

        const updateBundleSelectionInput = () => {
            const bundleInput = bundleSelector?.querySelector('input[name="properties[_bundle_selection]"]');
            if (!bundleInput) return;

            const selects = bundleSelector.querySelectorAll('select');
            bundleInput.value = [...selects].map((select) => select.value).filter(Boolean).join(' <> ');
        };

        const syncNewSelection = (input, dispatchEvent = true) => {
            const fieldset = input.closest('fieldset');
            if (!fieldset) return;

            const selectedValue = fieldset.querySelector('.product-bundle-picker__selected-value');
            const selectedLabel = input.nextElementSibling?.getAttribute('aria-label') || input.value;
            if (selectedValue) selectedValue.textContent = selectedLabel;

            const optionKey = fieldset.dataset.optionKey;
            const select = optionKey && root
                ? bundleSelector?.querySelector(`select[data-option-key="${CSS.escape(optionKey)}"]`) ||
                root.querySelector(`#${CSS.escape(optionKey)}, select[data-option-key="${CSS.escape(optionKey)}"]`)
                : null;

            if (select && select.value !== input.value) {
                select.value = input.value;
                select.dispatchEvent(new Event('change', { bubbles: true }));
            }

            updateBundleSelectionInput();

            if (dispatchEvent) {
                picker.dispatchEvent(
                    new CustomEvent('bundle-picker:change', {
                        bubbles: true,
                        detail: {
                            optionName: fieldset.dataset.optionKey,
                            value: input.value,
                            inputElement: input,
                        },
                    })
                );
            }
        };

        picker.addEventListener('change', (event) => {
            const input = event.target;
            if (input?.matches('.product-bundle-picker__swatch-input')) {
                syncNewSelection(input);
            }
        });

        picker.querySelectorAll('.product-bundle-picker__swatch-input:checked').forEach((input) => {
            syncNewSelection(input, false);
        });
    });
})();